import {ElementType, forwardRef, PropsWithChildren} from "react";
import React from "react";
import cn from "classnames";

import * as styles from "./Container.module.css";

interface IProps extends React.HTMLAttributes<HTMLElement> {
    as?: ElementType;
    fluid?: boolean;
    maxWidthVariant?: "md" | "lg";
}

export const Container = forwardRef((props: PropsWithChildren<IProps>, ref) => {
    const {as, className, fluid, maxWidthVariant = "lg", ...restProps} = props;

    const Element = as || "div";

    const containerClass = cn(styles.container, {[styles.containerMd]: maxWidthVariant === "md", [styles.containerLg]: maxWidthVariant === "lg"});

    return (
        <Element className={cn(fluid ? styles.containerFluid : containerClass, className)} ref={ref} {...restProps}>
            {props.children}
        </Element>
    );
});
import {ElementType, forwardRef, PropsWithChildren} from "react";
import React from "react";
import cn from "classnames";

import * as styles from "./Container.module.css";

interface IProps extends React.HTMLAttributes<HTMLElement> {
    as?: ElementType;
    fluid?: boolean;
    maxWidthVariant?: "md" | "lg";
}

export const Container = forwardRef((props: PropsWithChildren<IProps>, ref) => {
    const {as, className, fluid, maxWidthVariant = "lg", ...restProps} = props;

    const Element = as || "div";

    const containerClass = cn(styles.container, {[styles.containerMd]: maxWidthVariant === "md", [styles.containerLg]: maxWidthVariant === "lg"});

    return (
        <Element className={cn(fluid ? styles.containerFluid : containerClass, className)} ref={ref} {...restProps}>
            {props.children}
        </Element>
    );
});
